"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Cursor = (function (_super) {
    __extends(Cursor, _super);
    function Cursor(props) {
        return _super.call(this, props) || this;
    }
    Cursor.prototype.render = function () {
        var CursorClassName = this.props.cursorClassName ? this.props.cursorClassName : undefined;
        var color = '#FF000F';
        if (this.props.cursorType && this.props.cursorType === 'footer') {
            color = '#262626';
        }
        var h;
        switch (this.props.cursorSize) {
            case 1:
                h = React.createElement("h1", { className: CursorClassName },
                    React.createElement("div", { style: { color: "" + color } }, " \u2014 "),
                    this.props.children);
                break;
            case 2:
                h = React.createElement("h2", { className: CursorClassName },
                    React.createElement("div", { style: { color: "" + color } }, " \u2014 "),
                    this.props.children);
                break;
            case 3:
                h = React.createElement("h3", { className: CursorClassName },
                    React.createElement("div", { style: { color: "" + color } }, " \u2014 "),
                    this.props.children);
                break;
            case 4:
                h = React.createElement("h4", { className: CursorClassName },
                    React.createElement("div", { style: { color: "" + color } }, " \u2014 "),
                    this.props.children);
                break;
            case 5:
                h = React.createElement("h5", { className: CursorClassName },
                    React.createElement("div", { style: { color: "" + color } }, " \u2014 "),
                    this.props.children);
                break;
            case 6: h = React.createElement("h6", { className: CursorClassName },
                React.createElement("div", { style: { color: "" + color } }, " \u2014 "),
                this.props.children);
            default:
                break;
        }
        return (React.createElement("div", null, h));
    };
    return Cursor;
}(React.Component));
exports.Cursor = Cursor;
//# sourceMappingURL=Cursor.js.map